import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import {
    CAMPUS_EMAIL_UNVERIFIED,
    CAMPUS_EMAIL_VERIFIED,
} from 'constants/customer';
import ControlTemplate from './ControlTemplate';
import { Translate } from 'react-redux-i18n';

const Component = ({ status }) => {
    let el;
    const colorMap = {
        [CAMPUS_EMAIL_VERIFIED]: 'success',
        [CAMPUS_EMAIL_UNVERIFIED]: 'warning',
    };

    switch (status) {
    case CAMPUS_EMAIL_VERIFIED:
    case CAMPUS_EMAIL_UNVERIFIED:
        el = (
            <Badge color={ colorMap[status] }>
                <Translate value={ `customer.campus_email_status_${ status }` } />
            </Badge>
        );
        break;
    default:
        el = (
            <Badge color="secondary">
                <Translate value="unknown" />
            </Badge>
        );
        break;
    }

    return (
        <ControlTemplate large captionKey="customer.email_status" required={ false }>
            { el }
        </ControlTemplate>
    );
};

Component.propTypes = {
    status: PropTypes.number,
};
Component.defaultProps = {
    status: undefined,
};

export default Component;
